import React from 'react';
import {
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputRightAddon,
} from '@wegroup/design-system';

// Types
import { Change } from '../../../../../../../types/Form';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import { prefilledInputComponentStyling } from '../../../../constants/InputComponentStyling';
import { getFlowsDataTestId } from '../../../../utils/testUtils';
import { Inputs } from '../../../../types/Enums';

interface Props {
  question: FlowsQuestion;
}

const PercentageInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { onBlur, value, onChange },
    prefilled,
    error,
  } = useFlowInputComponent({ question });

  const handleOnChange = ({ name, value }: Change) => {
    if (value === '') onChange({ name, value: '' });
    else onChange({ name, value: Number(value) / 100 });
  };

  const handleOnBlur = () => {
    onBlur({
      name: question.id,
      value: value === '' || value == null ? '' : Number(value),
    });
  };

  return (
    <FormControl isInvalid={!!error}>
      <InputGroup>
        <Input
          type="number"
          min={0}
          max={100}
          variant="flows"
          name={question.id}
          value={
            value === '' || value == null
              ? ''
              : Number((Number(value) * 100).toFixed(2))
          }
          onChange={(e) => {
            handleOnChange({ name: question.id, value: e.target.value });
          }}
          onBlur={handleOnBlur}
          {...(prefilled && { sx: prefilledInputComponentStyling })}
          isDisabled={question.rules.is_disabled}
          data-test-id={getFlowsDataTestId(Inputs.PERCENTAGE, question)}
        />
        <InputRightAddon
          h="4.5rem"
          bg="white"
          color="text.gray"
          borderColor="#e4e4e4"
          boxShadow="base"
          opacity={question.rules.is_disabled ? '0.4' : '1'}
          {...(prefilled && { sx: prefilledInputComponentStyling })}
        >
          %
        </InputRightAddon>
      </InputGroup>
      {error?.message && <FormErrorMessage>{error?.message}</FormErrorMessage>}
    </FormControl>
  );
};

export default PercentageInputComponent;
